import React from 'react';
import logo from '../../../assets/images/faces/sendertech_logo.jpeg';
const Brand = () => <span className="workspace-brand">
  <img src={logo} alt="Sender Tech" width="99" height="50" />
  <span className="workspace-brand-copy"><strong>Sender Tech</strong><small>THERMOKING</small></span>
</span>;
export default Brand;
